"use client";
import { CR_URL } from "@/components/cryptoread/common/constant";
import Loading from "./loading";
import { useEffect } from "react";

export default function NotFound() {

  useEffect(()=>{
    window.location.href = CR_URL
  },[])

  return <Loading />;
}
